import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EPageTypes } from 'shared/types/common.interface';
import { TopicSuggestion } from 'redux/api/topics.api';

type TSpecialPage = EPageTypes.debate | EPageTypes.stream | null;

type TRemainingTime = {
  totalRemainingTime: number;
  roundRemainingTime: number;
};

export interface AppState {
  isLoading: boolean;
  specialPage: TSpecialPage;
  isEmailVerified: boolean;
  captcha: any;
  isAuth: boolean;
  remainingTime: TRemainingTime;
  local: { userLocale: string; is12HourFormat: boolean };
  topics: {
    url: string;
    suggestions: TopicSuggestion[];
    error: string | null;
  };
}

const initialState: AppState = {
  isLoading: false,
  specialPage: null,
  isEmailVerified: false,
  captcha: null,
  isAuth: false,
  remainingTime: {
    totalRemainingTime: 0,
    roundRemainingTime: 0,
  },
  local: {
    userLocale: navigator.language || 'en-US',
    is12HourFormat: ['en-US', 'en-CA', 'ph-PH'].includes(navigator.language || 'en-US'),
  },
  topics: {
    url: '',
    suggestions: [],
    error: null,
  },
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setSpecialPage: (state, action: PayloadAction<TSpecialPage>) => {
      state.specialPage = action.payload;
    },
    setEmailVerified: (state, action: PayloadAction<boolean>) => {
      state.isEmailVerified = action.payload;
    },
    setCaptcha: (state, action: PayloadAction<any>) => {
      window.console.log('action captcha: ', action.payload);
      state.captcha = action.payload;
    },
    setIsAuth: (state, action: PayloadAction<boolean>) => {
      state.isAuth = action.payload;
    },
    setRemainingTime: (state, action: PayloadAction<TRemainingTime>) => {
      state.remainingTime = action.payload;
    },
    setTopicUrl: (state, action: PayloadAction<string>) => {
      state.topics.url = action.payload;
    },
    setTopicSuggestions: (state, action: PayloadAction<TopicSuggestion[]>) => {
      state.topics.suggestions = action.payload;
    },
    setTopicError: (state, action: PayloadAction<string | null>) => {
      state.topics.error = action.payload;
    },
  },
});

export const {
  setLoading,
  setSpecialPage,
  setEmailVerified,
  setCaptcha,
  setIsAuth,
  setRemainingTime,
  setTopicUrl,
  setTopicSuggestions,
  setTopicError,
} = appSlice.actions;

export const appReducer = appSlice.reducer;
